import '@fontsource-variable/inter/wght.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-400.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-600.css';
import './styles.css';
import {
  DOWNLOAD_PLATFORMS,
  loadRelease,
  loadStoreBrand,
  type DownloadPlatform,
  type ReleaseState,
  type StoreBrand,
} from './release';
import { render, type ViewState } from './render';
import { STRINGS, pickLanguage, type Lang } from './strings';

const LANG_KEY = 'download_lang';

function readStored(): string | null {
  try {
    return localStorage.getItem(LANG_KEY);
  } catch {
    return null;
  }
}

function store(lang: Lang) {
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {
    // Private mode: the choice simply isn't remembered.
  }
}

const params = new URLSearchParams(location.search);
const root = document.getElementById('app')!;
let lang = pickLanguage(
  params.get('lang'),
  readStored(),
  navigator.languages ?? [navigator.language],
);
let brand: StoreBrand | null = null;
let releases: Partial<Record<DownloadPlatform, ReleaseState>> | null = null;

function draw() {
  const state: ViewState = {
    lang,
    t: STRINGS[lang],
    brand,
    releases,
    origin: location.origin,
    onToggleLanguage: () => {
      lang = lang === 'ar' ? 'en' : 'ar';
      store(lang);
      draw();
    },
    onRetry: () => void loadAll(),
  };
  render(root, state);
}

async function loadAll() {
  releases = {};
  draw();
  await Promise.all(
    DOWNLOAD_PLATFORMS.map(async (p) => {
      const state = await loadRelease(p);
      releases = { ...releases, [p]: state };
      draw();
    }),
  );
}

draw();
void loadStoreBrand(params.get('store')).then((b) => {
  brand = b;
  draw();
});
void loadAll();
